import { Page, Text, View, Document, StyleSheet, Font } from "@react-pdf/renderer";
import { Fragment } from "react";
import NanumGothicR from './Semilight.TTF';
import NanumGothic from './NanumSquareNeo-eHv.ttf';

    Font.register({
        family : 'NanumGothicR',
        src : NanumGothicR,
    })
    Font.register({
      family : 'NanumGothic',
      src : NanumGothic,
    })

const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
        fontFamily : 'NanumGothicR',
        display: 'flex',
        flexDirection: 'column',
        fontWeight: 'bold',
    },
    infoText: {
        margin: 5,
        fontSize: 9,
        textAlign: "justify",
        fontFamily: "NanumGothicR",
        fontWeight: 'bold',
    },
    pageNumber: {
        position: "absolute",
        fontSize: 9,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: "center",
        color: "grey",
    },
    listHeader: {
        borderTop: '1px solid black',
        borderLeft: '1px solid black',
        borderBottom: '1px solid black',
        width: '100%',
        minHeight: 12,
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#F8F8FF'
    },
    listContItm1: {
        borderRight: '1px solid black',
        flex: 2,
        minHeight: 12,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    listContItm2: {
        borderRight: '1px solid black',
        flex: 10,
        minHeight: 12,
        display: 'flex',
        justifyContent: 'center',
    },
    listContItm3: {
      borderRight: '1px solid black',
      flex: 1.55,
      minHeight: 12,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    listContItm4: {
      borderRight: '1px solid black',
      flex: 2,
      minHeight: 12,
      display: 'flex',
      justifyContent: 'center',
  },
    listContItm5: {
      borderRight: '1px solid black',
      flex: 4.45,
      minHeight: 12,
      display: 'flex',
      justifyContent: 'center',
    },
    listText: {
        fontSize: 9,
        marginLeft: 5,
    },
    listText2: {
      fontSize: 9,
      fontFamily: "NanumGothic",
    },
    listText3: {
      fontSize: 9,
      textAlign: 'center',
  },
    listMain: {
        borderLeft: '1px solid black',
        borderBottom: '1px solid black',
        width: '100%',
        minHeight: 12,
        display: 'flex',
        flexDirection: 'row'
    },
    listSum: {
        borderLeft: '1px solid black',
        borderBottom: '1px solid black',
        width: '100%',
        minHeight: 12,
        display: 'flex',
        flexDirection: 'row',
        backgroundColor: '#D3D3D3'
    },
    infoTextnum: {
      fontSize: 7,
      textAlign: "center",
      fontFamily: "NanumGothicR",
      fontWeight: 'bold',
    },
    circle: {
      width: 11,
      height: 11, 
      border: '1px solid black',
      borderRadius: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginLeft: 5
    },
    infoItm: {
      display: 'flex',
      flexDirection: 'row',
      minHeight: 12,
      width: '100%',
      borderLeft: '1px solid black',
      borderTop: '1px solid black',
    },
    infoItmBx: {
      flex: 1,
      minHeight: 12,
      borderRight: '1px solid black',
      display: 'flex',
      justifyContent: 'center'
    },
    infoItmBx1: {
      flex: 0.5,
      minHeight: 12,
      borderRight: '1px solid black',
      display: 'flex',
      justifyContent: 'center'
    },
    });

const ItemPrintPDF = ({data, picList, picId, dayDate, endDayDate}) => {
  return (
    <Document>

        <Page
          size='A4'
          style={styles.body}
        >
          <View style={styles.infoItm}>
            <View style={styles.infoItmBx1}>
              <Text style={styles.listText}>
                시작일
              </Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>
                {dayDate}
              </Text>
            </View>
            <View style={styles.infoItmBx1}>
              <Text style={styles.listText}>
                종료일
              </Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>
                {endDayDate}
              </Text>
            </View>
            <View style={styles.infoItmBx1}>
              <Text style={styles.listText}>
                담당자
              </Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>
                {picList.filter((it) => it['pic_id'] === picId)[0]['pic_name']}
              </Text>
            </View>
          </View>
          <View style={styles.listHeader}>
            <View style={styles.listContItm2}>
              <Text style={styles.listText}>
                상품명
              </Text>
            </View>
            <View style={styles.listContItm3}>
              <Text style={{fontSize: 9, marginLeft: 2}}>
                체크
              </Text>
            </View>
            <View style={styles.listContItm1}>
              <Text style={styles.listText}>
                주문번호
              </Text>
            </View>
            <View style={styles.listContItm4}>
              <Text style={styles.listText}>
                수량(단)
              </Text>
            </View>
            <View style={styles.listContItm5}>
              <Text style={styles.listText3}>
                구매처
              </Text>
            </View>
          </View>

          {data.map((itm, idx) => (
                <Fragment key={idx}>
                    {itm.map((item, index) => {
                        return (
                        <View key={index} style={styles.listMain}>
                            <View style={styles.listContItm2}>
                                <Text style={styles.listText}>
                                    {index === 0 ? item['it_name'] : ''}
                                </Text>
                            </View>
                            <View style={styles.listContItm3}>
                            </View>
                            <View style={styles.listContItm1}>
                                <Text style={styles.listText2}>{item['od_num']}</Text>
                            </View>
                            <View style={styles.listContItm4}>
                                <Text style={styles.listText}>
                                    {item['sum_num']}
                                </Text>
                            </View>
                            <View style={styles.listContItm5}>
                              <Text style={styles.listText3}>
                                  {index === 0 ? item['it_maker'] : ''}
                              </Text>
                            </View>
                        </View>)
                    })}

                    <View style={styles.listSum}>
                        <View style={styles.listContItm2}>
                            <Text style={styles.listText}>
                                합계
                            </Text>
                        </View>
                        <View style={styles.listContItm3}>
                        </View>
                        <View style={styles.listContItm1}>
                            <Text style={styles.listText}>
                            
                            </Text>
                        </View>
                        <View style={styles.listContItm4}>
                            <Text style={styles.listText}>
                                {itm[0]['sum_qty']}
                            </Text>
                        </View>
                        <View style={styles.listContItm5}>
                          <Text style={styles.listText}>
                          </Text>
                        </View>
                    </View>
                </Fragment>
          ))}


          

          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
          />
        </Page>
      
    </Document>
  )
}

export default ItemPrintPDF
